"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSuggestedActionsStyle;

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}
/* eslint no-empty-pattern: "off" */


function createSuggestedActionsStyle(_ref) {
  _objectDestructuringEmpty(_ref);

  return {};
}